<template>
    <div :class="['reply-wrapper', !replyInfo.parent_id ? 'is-reply-comment' : isShow ? 'is-show' : '']">
        <div class="reply-user-avatar">
            <img width="30" height="30" src="../../images/personal_center/avatar_default.png" v-if="userInfo.avatar.indexOf('?') === 0" @click="goUserPage">
            <img width="30" height="30" :src="userInfo.avatar" v-else @click="goUserPage">
        </div>
        <div class="reply-content">
            <p>回复<span class="nick-name">{{ replyInfo.commented_by.nick_name }}</span></p>
            <!-- 富文本 -->
            <change-editor
                class="reply-editor"
                :domId="`replyEditor${replyInfo.id}`"
                :parentId="replyInfo.parent_id || 0"
                :isFullScreen="true"
                :questionValue="filterXSS(replyInfo.replyContent)"
                @onChangeEditor="onChangeEditor">
            </change-editor>
            <div class="send-msg">
                <span class="cancel-btn" @click="onCancelComment(replyInfo)">取消</span>
                <span :class="['comment-btn', {'disabled': !isAllowReply}]" @click="replyComment(replyInfo)">
                    {{ isAnswer ? '提交回复' : '提交' }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import changeEditor from './wangEditor.vue';
    export default {
        components: { changeEditor },
        props: {
            replyInfo: {
                type: Object,
                default: () => {}
            },
            userInfo: {
                type: Object,
                default: () => {}
            },
            isAnswer: {
                type: Boolean,
                default: true
            },
            isShow: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isAllowReply () {
                let result = false
                if (this.replyInfo.replyContent &&  this.replyInfo.replyContent !== '<p><br></p>') {
                    result = true
                }
                return result
            }
        },
        methods: {
            goUserPage () {
                let routeData = this.$router.resolve({
                    path: '/s-mart/personal_center/'
                });
                window.open(routeData.href, '_blank');
            },
            onCancelComment (reply) {
                this.$emit('onCancelComment', reply)
            },
            replyComment (reply) {
                if (this.isAllowReply) {
                    this.$emit('replyComment', reply)
                }
            },
            onChangeEditor (val, domId, parentId) {
                this.$emit('onChangeEditor', val, domId, parentId)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .reply-wrapper {
        display: flex;
        height: 0px;
        overflow: hidden;
        transition: all .5s;
        .reply-user-avatar{
            margin-right: 10px;
            img {
                border-radius: 50%;
                cursor: pointer;
            }
        }
        .reply-content{
            width: 692px;
            font-size: 12px;
            p {
                margin: 8px 0 10px;
                .nick-name {
                    margin-left: 5px;
                    font-weight: 400;
                }
            }
            .nick-name {
                margin: 10px 0;
                color: #313238;
                font-weight: 700;
            }
            .send-msg{
                margin-top: 14px;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .cancel-btn, .comment-btn {
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    border-radius: 2px;
                    cursor: pointer;
                }
                .cancel-btn {
                    width: 68px;
                    border: 1px solid #c4c6cc;
                    border-radius: 3px;
                    color: #63656e;
                    margin-right: 8px;
                }
                .comment-btn {
                    width: 86px;
                    color: #fff;
                    background: #3a84ff;
                    &.disabled{
                        background: #dcdee5;
                        cursor: not-allowed;
                    }
                }
            }
        }
        &.is-reply-comment {
            height: 245px;
            overflow: initial;
        }
        &.is-show {
            height: 245px;
            overflow: initial;
            transition: initial;
            animation: replyShow .5s ease;
        }
    }
    @keyframes replyShow {
        0% {
            height: 0;
            overflow: hidden;
        }
        100% {
            height: 245px;
            overflow: initial;
        }
    }
</style>



// WEBPACK FOOTER //
// reply.vue?d5393098